<template>
    <div class="previewer">
        <div class="previewer__loading"
                v-bind:visible="loading ? '' : null">
            <p>Loading...</p>
        </div>

        <div class="previewer__content page page--blackborderless"
                v-bind:visible="!!error ? '' : null">
            <p class="page__title previewer__title">{{error}}</p>

            <a href="#"
                class="button button--bite">
                <span class="button__text">Close overlay</span>
            </a>
        </div>

        <div class="previewer__content page page--blackborderless"
                v-if="!!slide"
                v-bind:visible="showContent ? '' : null">
            <a href="#"
                active
                class="button button--icon previewer__close">
                <img v-bind:src="themeRoot + '/img/icon-cross.svg'"
                        alt="A cross"
                        class="button__icon" />
            </a>

            <h1 class="page__title previewer__title">
                <span v-html="slide.formattedTitle"></span>
            </h1>

            <img v-bind:src="slide.image.sizes['content-full']"
                    v-bind:alt="slide.image.alt"
                    data-zoomable
                    class="image previewer__image" />

            <dl class="page__deflist">
                <template v-for="(value, label) in slide.fields">
                    <dt>{{label}}</dt>
                    <dd v-if="Array.isArray(value)">
                        <ul class="page__ulist">
                            <li v-for="val in value"
                                v-html="val"></li>
                        </ul>
                    </dd>

                    <dd v-else
                        v-html="value"></dd>
                </template>

                <!-- We only show the direct link in the previewer -->
                <dt>Direct link</dt>
                <dd>
                    <a v-bind:href="slide.permalink"
                        class="previewer__permalink">
                        {{slide.permalink}}
                    </a>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue';
    import { $ } from 'donot';

    export default {
        props : {
            error : [Boolean, null],
            loading : Boolean,
            slide : [Object, null],
            showContent : Boolean
        },

        setup() {
            const themeRoot = ref($('meta[name="theme_root"]').getAttribute('content'));
            return { themeRoot };
        }
    };
</script>